import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgramsTab = ({ institution }) => {
  return (
    <div className="space-y-6">
      {institution?.programs?.map((program, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex flex-col lg:flex-row lg:items-start gap-4">
            <div className="flex-1">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                    {program?.name}
                  </h3>
                  <div className="flex flex-wrap gap-2 mb-3">
                    <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded">
                      {program?.degree}
                    </span>
                    <span className="px-2 py-1 bg-secondary/10 text-secondary text-xs font-medium rounded">
                      {program?.duration}
                    </span>
                    <span className="px-2 py-1 bg-accent/10 text-accent text-xs font-medium rounded">
                      {program?.language}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-lg font-semibold text-foreground">{program?.fees} MAD</div>
                  <div className="text-sm text-muted-foreground">par an</div>
                </div>
              </div>

              <p className="text-muted-foreground mb-4">{program?.description}</p>

              {/* Entry Requirements */}
              <div className="mb-4">
                <h4 className="font-medium text-foreground mb-2">Conditions d'admission</h4>
                <div className="space-y-2">
                  {program?.requirements?.map((req, reqIndex) => (
                    <div key={reqIndex} className="flex items-center gap-2">
                      <Icon name="Check" size={16} className="text-success" />
                      <span className="text-sm text-muted-foreground">{req}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Specializations */}
              {program?.specializations && (
                <div>
                  <h4 className="font-medium text-foreground mb-2">Spécialisations disponibles</h4>
                  <div className="flex flex-wrap gap-2">
                    {program?.specializations?.map((spec, specIndex) => (
                      <span key={specIndex} className="px-3 py-1 bg-muted text-foreground text-sm rounded-full">
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="lg:w-48 space-y-3">
              <button className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth text-sm font-medium">
                Candidater
              </button>
              <button className="w-full px-4 py-2 border border-border rounded-lg hover:bg-muted transition-smooth text-sm font-medium">
                Plus d'infos
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgramsTab;